import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { getFileStatus } from "../../utils/file";
import { fileActions } from "./actions";
import { FileState, FileUploadStatus } from "./types";

const initialState: FileState = {
  templates: [],
  users: [],
  results: {
    data: [],
    total: 0,
  },
};

const SKIP_ACTION_STATUS = [
  FileUploadStatus.Waiting,
  FileUploadStatus.Processing,
];

const DISABLE_DOWNLOAD_STATUS = [
  FileUploadStatus.Waiting,
  FileUploadStatus.Processing,
  FileUploadStatus.SystemError,
  FileUploadStatus.UploadError,
];

export function FileReducer(state = initialState, action: Action): FileState {
  if (isType(action, fileActions.getFileUploadTemplates.done)) {
    return {
      ...state,
      templates: action.payload.result.data.map((template) => ({
        id: template.template_id,
        name: template.template_name,
      })),
    };
  }

  if (isType(action, fileActions.getFileUploadUsers.done)) {
    return {
      ...state,
      users: action.payload.result.data.map((user) => ({
        id: user.id,
        name: user.full_name,
      })),
    };
  }

  if (isType(action, fileActions.getFileUploadResults.done)) {
    return {
      ...state,
      results: {
        data: action.payload.result.data.map((result) => ({
          id: result.upload_result_id,
          fileName: result.file_name,
          fileSize: result.file_size,
          userName: result.user_name,
          menuName: result.menu_name,
          templateName: result.template_name,
          uploadDate: result.upload_datetime,
          result: getFileStatus(result.status),
          disabled: SKIP_ACTION_STATUS.includes(result.status),
          disabledDownload: DISABLE_DOWNLOAD_STATUS.includes(result.status),
          disabledDownloadCSV: result.status !== FileUploadStatus.Success,
        })),
        total: action.payload.result.total,
      },
    };
  }

  if (isType(action, fileActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
